import { useContext } from "react";
import { DashboardChatContext } from "@/contexts/dashboardChatDefs";

export function useDashboardChat() {
  return useContext(DashboardChatContext);
}
